import React, { forwardRef } from "react";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/landing";
type CtaButtonProps = {
  label: string;
  caption?: string;
  className?: string;
};
export const CtaButton = forwardRef<HTMLDivElement, CtaButtonProps>(function CtaButton({
  label,
  caption,
  className = ""
}, ref) {
  return <div ref={ref} className={`mx-auto flex w-full max-w-xl flex-col items-center ${className}`} data-id="element-124" data-mp="cjhj4c9slsmk">
      <a href={CHECKOUT_URL} className="animate-cta-pulse group flex w-full items-center justify-center gap-3 rounded-2xl bg-gold px-5 py-5 text-center font-display text-[22px] font-extrabold uppercase leading-tight tracking-wide text-ink shadow-[0_10px_30px_-8px_rgba(250,204,21,0.6)] transition-[transform,background-color] duration-150 ease-out hover:bg-gold-deep active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-cyan sm:text-2xl" data-id="element-125" data-mp="qir1nilh0ytp">
        <span data-id="element-126" data-mp="15b18yf0wa4xj">{label}</span>
        <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-127" data-mp="157n512cl1nnz" />
      </a>
      {caption && <p className="mt-3 text-center text-[13px] font-medium text-mist" data-id="element-128" data-mp="39z9kz43f1p56">{caption}</p>}
    </div>;
});